import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ReportsService from "../../services/ReportsService";

export const fetchMerchantOfferPerformanceReport = createAsyncThunk(
  "report/fetchMerchantOfferPerformanceReport",
  async (data) => {
    try {
      const res = await ReportsService.getMerchantOfferPerformanceReport(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchMerchantOfferPerformanceReportExport = createAsyncThunk(
  "report/fetchMerchantOfferPerformanceReportExport",
  async (data) => {
    try {
      const res = await ReportsService.getMerchantOfferPerformanceReportExport(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchBranchOfferPerformanceReport = createAsyncThunk(
  "report/fetchBranchOfferPerformanceReport",
  async (data) => {
    try {
      const res = await ReportsService.getBranchOfferPerformanceReport(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchBranchOfferPerformanceReportExport = createAsyncThunk(
  "report/fetchBranchOfferPerformanceReportExport",
  async (data) => {
    try {
      const res = await ReportsService.getBranchOfferPerformanceReportExport(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchCustomerInteractionReport = createAsyncThunk(
  "report/fetchCustomerInteractionReport",
  async (data) => {
    try {
      const res = await ReportsService.getCustomerInteractionReport(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchCustomerInteractionReportExport = createAsyncThunk(
  "report/fetchCustomerInteractionReportExport",
  async (data) => {
    try {
      const res = await ReportsService.getCustomerInteractionReportExport(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchBranchCustomerInteractionReport = createAsyncThunk(
  "report/fetchBranchCustomerInteractionReport",
  async (data) => {
    try {
      const res = await ReportsService.getBranchCustomerInteractionReport(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchBranchCustomerInteractionReportExport = createAsyncThunk(
  "report/fetchBranchCustomerInteractionReportExport",
  async (data) => {
    try {
      const res = await ReportsService.getBranchCustomerInteractionReportExport(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchMerchantLoyaltyProgramReport = createAsyncThunk(
  "report/fetchMerchantLoyaltyProgramReport",
  async (data, { rejectWithValue }) => {
    try {
      const res = await ReportsService.getMerchantLoyaltyProgramReport(data);
      return res.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchMerchantLoyaltyProgramReportExport = createAsyncThunk(
  "report/fetchMerchantLoyaltyProgramReportExport",
  async (data, { rejectWithValue }) => {
    try {
      const res = await ReportsService.getMerchantLoyaltyProgramReportExport(data);
      return res.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchBranchLoyaltyProgramReport = createAsyncThunk(
  "report/fetchBranchLoyaltyProgramReport",
  async (data, { rejectWithValue }) => {
    try {
      const res = await ReportsService.getBranchLoyaltyProgramReport(data);
      return res.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchBranchLoyaltyProgramReportExport = createAsyncThunk(
  "report/fetchBranchLoyaltyProgramReportExport",
  async (data, { rejectWithValue }) => {
    try {
      const res = await ReportsService.getBranchLoyaltyProgramReportExport(data);
      return res.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchMerchantTransctionReport = createAsyncThunk(
  "report/fetchMerchantTransctionReport",
  async (data, { rejectWithValue }) => {
    try {
      const res = await ReportsService.getMerchantTransactionReport(data);
      return res.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchMerchantTransctionReportExport = createAsyncThunk(
  "report/fetchMerchantTransctionReportExport",
  async (data, { rejectWithValue }) => {
    try {
      const res = await ReportsService.getMerchantTransactionReportExport(data);
      return res.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);


export const fetchBranchTransctionReport = createAsyncThunk(
  "report/fetchBranchTransctionReport",
  async (data, { rejectWithValue }) => {
    try {
      const res = await ReportsService.getBranchTransactionReport(data);
      return res.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchBranchTransctionReportExport = createAsyncThunk(
  "report/fetchBranchTransctionReportExport",
  async (data, { rejectWithValue }) => {
    try {
      const res = await ReportsService.getBranchTransactionReportExport(data);
      return res.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  merchantOfferPerformanceReport: null,
  customertInteractionReport: null,
  merchantLoyaltyProgramReport: [],
  merchantTransactionReport: [],
  branchOfferPerformanceReport: null,
  branchCustomertInteractionReport: null,
  branchLoyaltyProgramReport: [],
  branchTransactionReport: [],
  total_redeem: 0,
  total_sales: 0,
  total_customer_code_usage: 0,
  total_pages: 0,
  total_records: 0,
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {},
  extraReducers(builder) {
    // Get Merchant Offer Performance Report
    builder
      .addCase(fetchMerchantOfferPerformanceReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchMerchantOfferPerformanceReport.fulfilled,
        (state, { payload }) => {
          state.loading = false;
          state.merchantOfferPerformanceReport = payload.data;
          state.total_pages = payload.data.total_pages;
          state.total_records = payload.data.total_records;
        }
      )
      .addCase(fetchMerchantOfferPerformanceReport.rejected, (state) => {
        state.loading = false;
      });

    // Get Merchant Customer Interaction Report
    builder
      .addCase(fetchCustomerInteractionReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchCustomerInteractionReport.fulfilled,
        (state, { payload }) => {
          state.loading = false;
          state.customertInteractionReport = payload.data;
          state.total_pages = payload.data.total_pages;
          state.total_records = payload.data.total_records;
        }
      )
      .addCase(fetchCustomerInteractionReport.rejected, (state) => {
        state.loading = false;
      });

    // Get Merchant Loyalty Program Report
    builder
      .addCase(fetchMerchantLoyaltyProgramReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchMerchantLoyaltyProgramReport.fulfilled,
        (state, { payload }) => {
          state.loading = false;
          state.merchantLoyaltyProgramReport = payload.data;
          state.total_pages = payload.data.total_pages;
          state.total_records = payload.data.total_records;
        }
      )
      .addCase(fetchMerchantLoyaltyProgramReport.rejected, (state) => {
        state.loading = false;
        state.merchantLoyaltyProgramReport = [];
        state.total_pages = 0;
        state.total_records = 0;
      });

    // Get Merchant Transaction Report
    builder
      .addCase(fetchMerchantTransctionReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchMerchantTransctionReport.fulfilled,
        (state, { payload }) => {
          state.loading = false;
          state.merchantTransactionReport = payload.data;
          state.total_redeem = payload.data.total_redeemed_offers;
          state.total_sales = payload.data.total_sale;
          state.total_customer_code_usage =
            payload.data.total_customer_code_usage;
          state.total_pages = payload.data.total_pages;
          state.total_records = payload.data.total_records;
        }
      )
      .addCase(fetchMerchantTransctionReport.rejected, (state) => {
        state.loading = false;
        state.merchantTransactionReport = [];
        state.total_redeem = 0;
        state.total_sales = 0;
        state.total_customer_code_usage = 0;
        state.total_pages = 0;
        state.total_records = 0;
      });

    //  Get Branch Offer Performance Report
    builder
      .addCase(fetchBranchOfferPerformanceReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchBranchOfferPerformanceReport.fulfilled,
        (state, { payload }) => {
          state.loading = false;
          state.branchOfferPerformanceReport = payload.data;
          state.total_pages = payload.data.total_pages;
          state.total_records = payload.data.total_records;
        }
      )
      .addCase(fetchBranchOfferPerformanceReport.rejected, (state) => {
        state.loading = false;
      });

    // Get Branch Customer Interaction Report
    builder
      .addCase(fetchBranchCustomerInteractionReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchBranchCustomerInteractionReport.fulfilled,
        (state, { payload }) => {
          state.loading = false;
          state.branchCustomertInteractionReport = payload.data;
          state.total_pages = payload.data.total_pages;
          state.total_records = payload.data.total_records;
        }
      )
      .addCase(fetchBranchCustomerInteractionReport.rejected, (state) => {
        state.loading = false;
      });

    // Get Branch Loyalty Program Report
    builder
      .addCase(fetchBranchLoyaltyProgramReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchBranchLoyaltyProgramReport.fulfilled,
        (state, { payload }) => {
          state.loading = false;
          state.branchLoyaltyProgramReport = payload.data;
          state.total_pages = payload.data.total_pages;
          state.total_records = payload.data.total_records;
        }
      )
      .addCase(fetchBranchLoyaltyProgramReport.rejected, (state) => {
        state.loading = false;
        state.branchLoyaltyProgramReport = [];
        state.total_pages = 0;
        state.total_records = 0;
      });

    // Get Branch Transaction Report
    builder
      .addCase(fetchBranchTransctionReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchTransctionReport.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.branchTransactionReport = payload.data;
        state.total_redeem = payload.data.total_redeemed_offers;
        state.total_sales = payload.data.total_sale;
        state.total_customer_code_usage =
          payload.data.total_customer_code_usage;
        state.total_pages = payload.data.total_pages;
        state.total_records = payload.data.total_records;
      })
      .addCase(fetchBranchTransctionReport.rejected, (state) => {
        state.loading = false;
        state.branchTransactionReport = [];
        state.total_redeem = 0;
        state.total_sales = 0;
        state.total_customer_code_usage = 0;
        state.total_pages = 0;
        state.total_records = 0;
      });
  },
});

export default reportSlice.reducer;
